

const ListCustodiansItemSchema = {
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default ListCustodiansItemSchema
